// src/components/about/AboutPage.styles.ts
import styled from 'styled-components';

export const AboutRoot = styled.section`
  background: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.text};
`;
